import { useReduxState } from 'hooks';
import { getFormattedDate } from 'lib/common';
import { Badge } from 'components/common';
import { Icon } from 'components/common/icons';

import type { PathCompletion } from 'shared-types';

interface Props {
  pathCompletion: Pick<PathCompletion, 'completionDate' | 'createdAt'>;
  showDate: boolean;
  showTooltip?: boolean;
  style?: React.CSSProperties;
}

const PathCompletionStatus = ({
  pathCompletion,
  showDate,
  showTooltip = true,
  style
}: Props) => {
  const { messages } = useReduxState();

  const hasBeenUpdated =
    getFormattedDate({ date: pathCompletion.createdAt }) !==
    getFormattedDate({ date: pathCompletion.completionDate });

  return (
    <div className="completion" style={style}>
      <Badge
        category="success-light"
        icon="check"
        isRounded={false}
        text={
          <span>
            {showDate
              ? getFormattedDate({ date: pathCompletion.completionDate })
              : messages.commonCompleted}

            {hasBeenUpdated ? (
              <span
                className="discrepancy"
                style={{
                  display: 'inline-block',
                  fontSize: '0.6rem',
                  marginTop: 1,
                  padding: '0 2px',
                  verticalAlign: 'top'
                }}
              >
                <Icon icon="asterisk" />
              </span>
            ) : null}
          </span>
        }
        tooltip={
          !showTooltip ? undefined : hasBeenUpdated ? (
            <div>
              <div className="item">
                <div className="label">
                  {messages.completionsCompletionDateOriginal}
                </div>
                <div className="value">
                  {getFormattedDate({ date: pathCompletion.createdAt })}
                </div>
              </div>
              <div className="item">
                <div className="label">
                  {messages.completionsCompletionDateUpdated}
                </div>
                <div className="value">
                  {getFormattedDate({ date: pathCompletion.completionDate })}
                </div>
              </div>
            </div>
          ) : showDate ? (
            messages.commonCompleted
          ) : (
            messages.commonCompleted +
            ` ${getFormattedDate({ date: pathCompletion.completionDate })}`
          )
        }
        tooltipProps={hasBeenUpdated ? { isLight: true } : {}}
      />

      <style jsx>{`
        .completion {
          display: inline-block;
        }
        .item {
          display: flex;
          padding: 6px 3px;
        }
        .label {
          flex-grow: 1;
          margin-right: 20px;
        }
        .value {
          display: inline-flex;
        }
      `}</style>
    </div>
  );
};

export default PathCompletionStatus;
